import { List, ListItemButton, ListItemText, Menu, MenuItem } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { setSelectedCompany } from '../redux/slices/user';
import { useDispatch, useSelector } from '../redux/store';

export default function CompanyDropDown() {
  const dispatch = useDispatch();
  const { companiesList, selectedCompanyId } = useSelector((state) => state.user);
  const [isOpenList, setOpenList] = useState(null);

  const handleClickListItem = (event) => {
    setOpenList(event.currentTarget);
  };

  const handleMenuItemClick = (event, index) => {
    dispatch(setSelectedCompany(index + 1));
    setOpenList(null);
  };

  useEffect(() => {
    if (companiesList.length === 0) {
      // dispatch(getCompaniesList());
    }
  }, [dispatch, companiesList]);

  if (companiesList.length > 0) {
    let selectedIndex = selectedCompanyId - 1;
    if (selectedIndex >= companiesList.length) {
      dispatch(setSelectedCompany(1));
      selectedIndex = 0;
    }
    return (
      <>
        <List component="nav" aria-label="Device settings">
          <ListItemButton
            aria-haspopup="true"
            aria-controls="lock-menu"
            aria-label="when device is locked"
            onClick={handleClickListItem}
          >
            <ListItemText primary="Empresa seleccionada:" secondary={companiesList[selectedIndex].label} />
          </ListItemButton>
        </List>
        <Menu keepMounted id="lock-menu" anchorEl={isOpenList} open={Boolean(isOpenList)}>
          {companiesList.map((option, index) => (
            <MenuItem
              key={option.value}
              selected={index === selectedIndex}
              onClick={(event) => handleMenuItemClick(event, index)}
            >
              {option.label}
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  }
  return null;
}
